import { makeStyles } from '@material-ui/core'
import { Theme } from '@styles/theme/theme'

const useStyles = makeStyles((theme: Theme) => ({

  smoothText: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '15px',
    opacity: '0.5',
    margin: '20px',
    [theme.breakpoints.down('sm')]: {
      flex: 1,
      textAlign: 'center',
      margin: '0',
    }
  },

  pressEnter: {
    display: 'inline-block',
    margin: '0 20px 0 0',
  },

  button: {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    width: '203px',
    height: '56px',

    "& svg": {
      margin: "0 10px"
    },
    [theme.breakpoints.down('sm')]: {
      width: '48px',
      height: '48px',
      minWidth: 0,
      padding: 0
    }
  },

  buttonLastStep: {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    width: '100%',
    height: '56px',

    "& svg": {
      margin: "0 10px"
    }
  },

  itemGrow: {
    flexGrow: 2,
    paddingLeft: 20,
  },

  backContainer: {
    [theme.breakpoints.down('sm')]: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
    }
  },

  backButton: {
    border: "solid 2px",
    width: '56px',
    height: '56px',
    padding: 0,
    
    [theme.breakpoints.down('sm')]: {
      width: '48px',
      height: '48px',
      minWidth: 0,
    }
  }
}))

export default useStyles
